import React, { useEffect, useState } from "react";
import DataTables from "../../CommonDataTable/DataTable";
import config from "../../../../config/config";
import apiCalls from "../../../../config/apiCalls";
import ViewModal from "../../CommonModals/viewModal";
import NewUserModal from "../../CommonModals/NewUserModal";
import showToasterMessage from "../../../UI/ToasterMessage/toasterMessage";
import FormModal from "../../../Form/FormModal";
import store from "../../../App/store";
import filePath from "../../../../config/configSampleFiles";
import fetchMethodRequest from "../../../../config/service";
import RolePermissions from "../../CommonModals/Permissions";
import { useParams } from "react-router";
// config file

/**
 * !PLEASE DO NOT REMOVE THE BELOW FIELDS
 * !THESE FIELDS WILL BE REPLACED IN THE BACKEND AS PER REQUIREMENT
 * @Facilities
 * @Facilities
 * @facilities
 * @[{"textAlign":"center","width":47,"field":"Check Box","label":"Check Box","fieldType":"multiple","header":"","selectionMode":"multiple","show":true,"mobile":true,"displayInSettings":true},{"textAlign":"center","width":47,"field":"Sno","label":"SNo","header":"SNo","filter":false,"sortable":false,"placeholder":"Search","show":true,"mobile":true,"displayInSettings":true},{"name":"facilityName","type":"text","placeholder":"Facility Name","label":"Facility Name","width":110,"addFormOrder":1,"editFormOrder":1,"header":"Facility Name","derivedValue":"facilityName=facilityName=undefined","capitalizeTableText":true,"sortable":true,"filter":true,"id":"facilityName","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"globalSearchField":"true","controllerId":null,"textAlign":"Center","show":true,"field":"facilityName","showOrHideFields":[],"mobile":true,"displayInSettings":true,"fieldType":"Link","style":{"color":"#0e4768","cursor":"pointer","textTransform":"capitalize"}},{"name":"facilityEmail","type":"email","placeholder":"Facility Email","label":"Facility Email","width":"150px","addFormOrder":7,"editFormOrder":7,"header":"Facility Email","derivedValue":"facilityEmail=undefined","capitalizeTableText":false,"sortable":true,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"facilityEmail","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"textAlign":"Center","show":true,"field":"facilityEmail","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"address","type":"derivedFields","placeholder":"Address","label":"Address","width":"120px","addFormOrder":13,"editFormOrder":13,"stringType":"string","header":"Address","derivedValue":"address=street+city+state+zip","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":["street","city","state","zip"],"actionsNumber":[],"id":"address","displayinaddForm":false,"displayineditForm":false,"displayinregisterForm":false,"displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"textAlign":"Center","show":true,"field":"address","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"createdByName","type":"Text","placeholder":"Created By","label":"Created By","width":120,"header":"Created By","id":"createdByName","displayinlist":"true","globalSearchField":"false","controllerId":1001,"fieldType":"Text","textAlign":"Center","show":true,"field":"createdByName","mobile":true,"filter":true,"displayInSettings":true},{"name":"updatedByName","type":"Text","placeholder":"Updated By","label":"Updated By","width":120,"header":"Updated By","id":"updatedByName","displayinlist":"true","fieldType":"Text","textAlign":"Center","show":true,"filter":true,"field":"updatedByName","mobile":true,"displayInSettings":true},{"name":"created","type":"date","placeholder":"Created","label":"Created","width":90,"header":"Created","derivedValue":"created=undefined","actions":[],"actionsNumber":[],"id":"created","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"fieldType":"Date","dateFormat":"YYYY-MM-DD HH:mm:ss","textAlign":"Center","disabled":true,"show":true,"field":"created","mobile":true,"displayInSettings":true},{"name":"updated","type":"date","placeholder":"Updated","label":"Updated","width":90,"header":"Updated","derivedValue":"updated=undefined","actions":[],"actionsNumber":[],"id":"updated","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"fieldType":"Date","dateFormat":"YYYY-MM-DD HH:mm:ss","textAlign":"Center","disabled":true,"show":true,"field":"updated","mobile":true,"displayInSettings":true},{"name":"street","type":"text","placeholder":"Street","label":"Street","width":"130px","addFormOrder":8,"editFormOrder":8,"header":"Street","derivedValue":"street=street=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"street","displayinaddForm":"true","displayineditForm":"true","displayinlist":"false","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"textAlign":"Center","show":false,"field":"street","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"city","type":"text","placeholder":"City","label":"City","width":"130px","addFormOrder":9,"editFormOrder":9,"header":"City","derivedValue":"city=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"city","displayinaddForm":"true","displayineditForm":"true","displayinlist":"false","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"textAlign":"Center","show":false,"field":"city","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"state","type":"text","placeholder":"State","label":"State","width":"130px","addFormOrder":10,"editFormOrder":10,"header":"State","derivedValue":"state=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"state","displayinaddForm":"true","displayineditForm":"true","displayinlist":"false","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"textAlign":"Center","show":false,"field":"state","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"zip","type":"text","placeholder":"Zip","label":"Zip","width":"130px","addFormOrder":11,"editFormOrder":11,"header":"Zip","derivedValue":"zip=zip=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"zip","displayinaddForm":"true","displayineditForm":"true","displayinlist":"false","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"validationRequired":true,"regexPattern":"^[0-9]$","regexData":{"showMinField":false,"minLengthRequired":false,"minLengthText":null,"showMaxField":false,"maxLengthRequired":false,"maxLengthText":null,"alphabetsRequired":false,"showAlphaField":false,"numbersRequired":true,"showNumField":true,"specialCharRequired":false,"showSCharField":false,"specialCharText":null},"textAlign":"Center","show":false,"field":"zip","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"show":true,"textAlign":"center","width":60,"fieldType":"Actions","field":"Actions","header":"Actions","label":"Actions","filter":false,"sortable":false,"displayInSettings":true,"displayinServer":"false","displayinlist":"true","displayinaddForm":"false","displayineditForm":"false","mobile":true},{"show":true,"textAlign":"center","width":60,"fieldType":"Actions","field":"Actions","header":"Actions","label":"Actions","filter":false,"sortable":false,"displayInSettings":true,"displayinServer":"false","displayinlist":"true","displayinaddForm":"false","displayineditForm":"false","mobile":true}]
 * @[{"name":"facilityName","type":"text","placeholder":"Facility Name","label":"Facility Name","width":110,"addFormOrder":1,"editFormOrder":1,"derivedValue":"facilityName=facilityName=undefined","capitalizeTableText":true,"sortable":true,"filter":true,"id":"facilityName","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"globalSearchField":"true","controllerId":null,"show":true,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"fieldType":"Link","style":{"color":"#0e4768","cursor":"pointer","textTransform":"capitalize"},"isAddFormHidden":false,"isEditFormHidden":false},{"name":"facilityEmail","type":"email","placeholder":"Facility Email","label":"Facility Email","width":"150px","addFormOrder":7,"editFormOrder":7,"derivedValue":"facilityEmail=undefined","capitalizeTableText":false,"sortable":true,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"facilityEmail","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"show":true,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"isAddFormHidden":false,"isEditFormHidden":false},{"name":"created","type":"date","placeholder":"Created","label":"Created","width":90,"derivedValue":"created=undefined","actions":[],"actionsNumber":[],"id":"created","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"fieldType":"Date","dateFormat":"YYYY-MM-DD HH:mm:ss","disabled":true,"show":true,"mobile":true,"displayInSettings":true,"isAddFormHidden":true,"isEditFormHidden":true},{"name":"updated","type":"date","placeholder":"Updated","label":"Updated","width":90,"derivedValue":"updated=undefined","actions":[],"actionsNumber":[],"id":"updated","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"fieldType":"Date","dateFormat":"YYYY-MM-DD HH:mm:ss","disabled":true,"show":true,"mobile":true,"displayInSettings":true,"isAddFormHidden":true,"isEditFormHidden":true},{"name":"street","type":"text","placeholder":"Street","label":"Street","width":"130px","addFormOrder":8,"editFormOrder":8,"derivedValue":"street=street=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"street","displayinaddForm":"true","displayineditForm":"true","displayinlist":"false","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"show":true,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"isAddFormHidden":false,"isEditFormHidden":false},{"name":"city","type":"text","placeholder":"City","label":"City","width":"130px","addFormOrder":9,"editFormOrder":9,"derivedValue":"city=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"city","displayinaddForm":"true","displayineditForm":"true","displayinlist":"false","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"show":true,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"isAddFormHidden":false,"isEditFormHidden":false},{"name":"state","type":"text","placeholder":"State","label":"State","width":"130px","addFormOrder":10,"editFormOrder":10,"derivedValue":"state=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"state","displayinaddForm":"true","displayineditForm":"true","displayinlist":"false","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"show":true,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"isAddFormHidden":false,"isEditFormHidden":false},{"name":"zip","type":"text","placeholder":"Zip","label":"Zip","width":"130px","addFormOrder":11,"editFormOrder":11,"derivedValue":"zip=zip=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"zip","displayinaddForm":"true","displayineditForm":"true","displayinlist":"false","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"validationRequired":true,"regexPattern":"^[0-9]$","regexData":{"showMinField":false,"minLengthRequired":false,"minLengthText":null,"showMaxField":false,"maxLengthRequired":false,"maxLengthText":null,"alphabetsRequired":false,"showAlphaField":false,"numbersRequired":true,"showNumField":true,"specialCharRequired":false,"showSCharField":false,"specialCharText":null},"show":true,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"isAddFormHidden":false,"isEditFormHidden":false}]
 * @
 * @
 * @
 *
 *
 *
 */

const Tickets = (props) => {
  const [languageData, setLanguageData] = useState();
  const [rolePermission, setRolePermission] = useState();
  const [editSelectedRecord, setEditSelectedRecord] = useState(
    window.location.href.includes("edit")
  );
  const [addSelectedRecord, setAddSelectedRecord] = useState(
    window.location.href.includes("create")
  );
  const [viewSelectedRecord, setViewSelectedRecord] = useState(
    window.location.href.includes("view")
  );
  const [isOpenFormModal, setIsOpenFormModal] = useState(false);
  const [openNewUserModal, setopenNewUserModal] = useState(false);
  const [item, setItem] = useState({});
  const [newFormFields, setNewFormField] = useState([]);

  const params = useParams();
  useEffect(() => {
    let screenPermissions = RolePermissions.screenPermissions("Tickets");
    if (screenPermissions) {
      setRolePermission(screenPermissions);
    }
  }, []);

  const getDerivedStateFromProps = (props, state) => {
    let storeData = store.getState();
    let languageData =
      storeData &&
        storeData.settingsData &&
        storeData.settingsData.settings &&
        storeData.settingsData.settings.languageTranslation
        ? storeData.settingsData.settings.languageTranslation
        : "";
    return { languageData: languageData };
  };
  const setData = (props) => {
    let rowData = {};
    if (params.id) {
      rowData["_id"] = JSON.parse(params.id);
      return rowData;
    }
  };

  const getTableFields = () => {
    let roleTypes = [
      {
        label: "All",
        value: null,
      },
      {
        label: "Admin",
        value: "Admin",
      },
      {
        label: "Super Admin",
        value: "Super Admin",
      },
      {
        label: "User",
        value: "User",
      },
    ];
    let StatusTypes = [
      {
        label: "All",
        value: null,
      },
      {
        label: "Active",
        value: "Active",
      },
      {
        label: "Inactive",
        value: "Inactive",
      },
      {
        label: "Pending",
        value: "Pending",
      },
    ];
    let data = [
      {

        width: 30,
        field: "Sno",
        label: "SNo",
        header: "SNo",
        filter: false,
        sortable: false,
        placeholder: "Search",
        show: false,
        textAlign: "center",
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "ticketId",
        type: "text",
        placeholder: "Ticket Id",
        label: "Ticket Id ",
        width: 90,
        addFormOrder: 1,
        editFormOrder: 1,
        header: "Ticket Id",
        derivedValue: "ticketId=ticketId=undefined",
        capitalizeTableText: true,
        sortable: true,
        filter: false,
        id: "ticketId",
        textAlign: "center",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "false",
        required: false,
        globalSearchField: "true",
        controllerId: null,
        show: true,
        field: "ticketId",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "subject",
        type: "text",
        placeholder: "Subject",
        label: "Subject",
        width: "120px",
        addFormOrder: 1,
        editFormOrder: 1,
        header: "Subject",
        derivedValue: "subject=facilityName=undefined",
        capitalizeTableText: true,
        sortable: true,
        filter: false,
        id: "subject",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        // isFieldRequired: "true",
        // required: true,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "left",
        show: true,
        field: "subject",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        // fieldType: "Link",
        // style: {
        //   color: "#0e4768",
        //   cursor: "pointer",
        //   textTransform: "capitalize",
        // },
      },
      {
        name: "emailId",
        type: "email",
        placeholder: "Facility Email",
        label: "Email Id",
        width: "180px",
        addFormOrder: 7,
        editFormOrder: 7,
        header: "Email Id",
        derivedValue: "emailId=undefined",
        capitalizeTableText: false,
        sortable: true,
        isClickable: false,
        filter: true,
        actions: [],
        actionsNumber: [],
        id: "emailId",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        // isFieldRequired: "true",
        // required: true,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "left",
        show: true,
        field: "emailId",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "userName",
        type: "derivedFields",
        placeholder: "userName",
        label: "User Name",
        width: "180px",
        addFormOrder: 13,
        editFormOrder: 13,
        stringType: "string",
        header: "User Name",
        derivedValue: "userName=street+city+state+zip",
        capitalizeTableText: false,
        sortable: true,
        isClickable: false,
        filter: true,
        actions: ["street", "city", "state", "zip"],
        actionsNumber: [],
        id: "userName",
        displayinaddForm: false,
        displayineditForm: false,
        displayinregisterForm: false,
        displayinlist: "true",
        // isFieldRequired: "false",
        // required: false,
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: null,
        textAlign: "left",
        show: true,
        field: "userName",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "ticketCategory",
        type: "Text",
        placeholder: "Category",
        label: "Category",
        width: 120,
        header: "Category",
        sortable: true,
        filter: true,
        id: "category",
        displayinlist: "true",
        globalSearchField: "false",
        controllerId: 1001,
        fieldType: "Text",
        textAlign: "left",
        show: true,
        field: "ticketCategory",
        capitalizeTableText: true,
        mobile: true,
        filter: false,
        displayInSettings: true,
      },
      // {
      //     name: "created",
      //     type: "date",
      //     placeholder: "Category",
      //     label: "Created On",
      //     width: 120,
      //     header: "Created On",
      //     sortable: true,
      //     filter: true,
      //     id: "created",
      //     displayinlist: "true",
      //     globalSearchField: "false",
      //     controllerId: 1001,
      //     fieldType: "Text",
      //     textAlign: "left",
      //     show: true,
      //     field: "created",
      //     capitalizeTableText: true,
      //     mobile: true,
      //     filter: false,
      //     displayInSettings: true,
      // },
      {
        name: "message",
        type: "Text",
        placeholder: "message",
        label: "Message",
        width: 120,
        header: "Message",
        sortable: true,
        filter: true,
        id: "message",
        displayinlist: "true",
        globalSearchField: "false",
        controllerId: 1001,
        fieldType: "Text",
        textAlign: "left",
        show: true,
        field: "message",
        capitalizeTableText: true,
        mobile: true,
        filter: false,
        displayInSettings: true,
      },
      {
        name: "assignedTo",
        type: "Text",
        placeholder: "assignedTo",
        label: "AssignedTo",
        width: 120,
        header: "AssignedTo",
        sortable: true,
        filter: true,
        id: "assignedTo",
        displayinlist: "true",
        globalSearchField: "false",
        controllerId: 1001,
        fieldType: "Text",
        textAlign: "left",
        show: false,
        field: "assignedTo",
        capitalizeTableText: true,
        mobile: true,
        filter: false,
        displayInSettings: true,
      },
      {
        name: "created",
        type: "date",
        placeholder: "Category",
        label: "Updated On",
        width: 120,
        header: "Updated On",
        sortable: true,
        filter: true,
        id: "created",
        displayinlist: "true",
        globalSearchField: "false",
        controllerId: 1001,
        fieldType: "Text",
        textAlign: "left",
        show: true,
        field: "created",
        capitalizeTableText: true,
        mobile: true,
        filter: false,
        displayInSettings: true,
      },
      {
        name: "status",
        type: "Text",
        placeholder: "status",
        label: "Status",
        width: 120,
        header: "Status",
        sortable: true,
        filter: true,
        id: "status",
        displayinlist: "true",
        globalSearchField: "false",
        controllerId: 1001,
        fieldType: "Text",
        textAlign: "left",
        show: true,
        field: "status",
        capitalizeTableText: true,
        mobile: true,
        filter: false,
        displayInSettings: true,
      },
      {
        show: false,
        textAlign: "center",
        width: 60,
        fieldType: "Actions",
        field: "Actions",
        header: "Actions",
        label: "Actions",
        filter: false,
        sortable: false,
        displayInSettings: true,
        displayinServer: "false",
        displayinlist: "true",
        displayinaddForm: "false",
        displayineditForm: "false",
        mobile: true,
      },
    ];
    return data;
  };

  const getFormFields = () => {
    let statusTypes = [
      {
        label: "Active",
        value: "Active",
      },
      {
        label: "Inactive",
        value: "Inactive",
      },
      {
        label: "Pending",
        value: "Pending",
      },
    ];
    return [
      {
        name: "facilityName",
        type: "text",
        placeholder: "Facility Name",
        label: "Facility Name",
        width: 110,
        addFormOrder: 1,
        editFormOrder: 1,
        derivedValue: "facilityName=facilityName=undefined",
        capitalizeTableText: true,
        sortable: true,
        filter: true,
        id: "facilityName",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "true",
        required: false,
        globalSearchField: "true",
        controllerId: null,
        show: true,
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        fieldType: "Link",
        style: {
          color: "#0e4768",
          cursor: "pointer",
          textTransform: "capitalize",
        },
        isAddFormHidden: false,
        isEditFormHidden: false,
      },
      {
        name: "facilityEmail",
        type: "email",
        placeholder: "Facility Email",
        label: "Facility Email",
        width: "150px",
        addFormOrder: 7,
        editFormOrder: 7,
        derivedValue: "facilityEmail=undefined",
        capitalizeTableText: false,
        sortable: true,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "facilityEmail",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "true",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        show: true,
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        isAddFormHidden: false,
        isEditFormHidden: false,
      },
      {
        name: "street",
        type: "text",
        placeholder: "Street",
        label: "Street",
        width: "130px",
        addFormOrder: 8,
        editFormOrder: 8,
        derivedValue: "street=street=undefined",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "street",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "false",
        isFieldRequired: "true",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: null,
        show: true,
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        isAddFormHidden: false,
        isEditFormHidden: false,
      },
      {
        name: "city",
        type: "text",
        placeholder: "City",
        label: "City",
        width: "130px",
        addFormOrder: 9,
        editFormOrder: 9,
        derivedValue: "city=undefined",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "city",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "false",
        isFieldRequired: "true",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: null,
        show: true,
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        isAddFormHidden: false,
        isEditFormHidden: false,
      },
      {
        name: "state",
        type: "text",
        placeholder: "State",
        label: "State",
        width: "130px",
        addFormOrder: 10,
        editFormOrder: 10,
        derivedValue: "state=undefined",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "state",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "false",
        isFieldRequired: "true",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: null,
        show: true,
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        isAddFormHidden: false,
        isEditFormHidden: false,
      },
      {
        name: "zip",
        type: "text",
        placeholder: "Zip",
        label: "Zip",
        width: "130px",
        addFormOrder: 11,
        editFormOrder: 11,
        derivedValue: "zip=zip=undefined",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "zip",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "false",
        // isFieldRequired: "true",
        // required: true,
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: null,
        validationRequired: true,
        // regexPattern: "^[0-9]$",
        regexData: {
          showMinField: false,
          minLengthRequired: false,
          minLengthText: null,
          showMaxField: false,
          maxLengthRequired: false,
          maxLengthText: null,
          alphabetsRequired: false,
          showAlphaField: false,
          numbersRequired: true,
          showNumField: true,
          specialCharRequired: false,
          showSCharField: false,
          specialCharText: null,
        },
        show: true,
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        isAddFormHidden: false,
        isEditFormHidden: false,
      },
    ];
  };

  const submit = async (item) => {
    setIsOpenFormModal(true);
    // await this.formModalRef.getRowData(item, 'edit');
  };
  const getMobileTableFields = () => {
    let data = [
      {
        textAlign: "center",
        width: 47,
        field: "Check Box",
        label: "Check Box",
        fieldType: "multiple",
        header: "",
        selectionMode: "multiple",
        show: true,
        mobile: true,
        displayInSettings: true,
      },
      {
        textAlign: "center",
        width: 47,
        field: "Sno",
        label: "SNo",
        header: "SNo",
        filter: false,
        sortable: false,
        placeholder: "Search",
        show: true,
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "facilityName",
        type: "text",
        placeholder: "Facility Name",
        label: "Facility Name",
        width: 110,
        addFormOrder: 1,
        editFormOrder: 1,
        header: "Facility Name",
        derivedValue: "facilityName=facilityName=undefined",
        capitalizeTableText: true,
        sortable: true,
        filter: true,
        id: "facilityName",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "true",
        required: true,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "Center",
        show: true,
        field: "facilityName",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        fieldType: "Link",
        style: {
          color: "#0e4768",
          cursor: "pointer",
          textTransform: "capitalize",
        },
      },
      {
        name: "facilityEmail",
        type: "email",
        placeholder: "Facility Email",
        label: "Facility Email",
        width: "150px",
        addFormOrder: 7,
        editFormOrder: 7,
        header: "Facility Email",
        derivedValue: "facilityEmail=undefined",
        capitalizeTableText: false,
        sortable: true,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "facilityEmail",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "true",
        required: true,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "Center",
        show: true,
        field: "facilityEmail",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "address",
        type: "derivedFields",
        placeholder: "Address",
        label: "Address",
        width: "120px",
        addFormOrder: 13,
        editFormOrder: 13,
        stringType: "string",
        header: "Address",
        derivedValue: "address=street+city+state+zip",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: ["street", "city", "state", "zip"],
        actionsNumber: [],
        id: "address",
        displayinaddForm: false,
        displayineditForm: false,
        displayinregisterForm: false,
        displayinlist: "true",
        isFieldRequired: "false",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: null,
        textAlign: "Center",
        show: true,
        field: "address",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "createdByName",
        type: "Text",
        placeholder: "Created By",
        label: "Created By",
        width: 120,
        header: "Created By",
        id: "createdByName",
        displayinlist: "true",
        globalSearchField: "false",
        controllerId: 1001,
        fieldType: "Text",
        textAlign: "Center",
        show: true,
        field: "createdByName",
        mobile: true,
        filter: true,
        displayInSettings: true,
      },
      {
        name: "updatedByName",
        type: "Text",
        placeholder: "Updated By",
        label: "Updated By",
        width: 120,
        header: "Updated By",
        id: "updatedByName",
        displayinlist: "true",
        fieldType: "Text",
        textAlign: "Center",
        show: true,
        filter: true,
        field: "updatedByName",
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "created",
        type: "date",
        placeholder: "Created",
        label: "Created",
        width: 90,
        header: "Created",
        derivedValue: "created=undefined",
        actions: [],
        actionsNumber: [],
        id: "created",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        globalSearchField: "false",
        controllerId: null,
        fieldType: "Date",
        dateFormat: "YYYY-MM-DD HH:mm:ss",
        textAlign: "Center",
        disabled: true,
        show: true,
        field: "created",
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "updated",
        type: "date",
        placeholder: "Updated",
        label: "Updated",
        width: 90,
        header: "Updated",
        derivedValue: "updated=undefined",
        actions: [],
        actionsNumber: [],
        id: "updated",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        globalSearchField: "false",
        controllerId: null,
        fieldType: "Date",
        dateFormat: "YYYY-MM-DD HH:mm:ss",
        textAlign: "Center",
        disabled: true,
        show: true,
        field: "updated",
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "street",
        type: "text",
        placeholder: "Street",
        label: "Street",
        width: "130px",
        addFormOrder: 8,
        editFormOrder: 8,
        header: "Street",
        derivedValue: "street=street=undefined",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "street",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "false",
        isFieldRequired: "true",
        required: true,
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: null,
        textAlign: "Center",
        show: false,
        field: "street",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "city",
        type: "text",
        placeholder: "City",
        label: "City",
        width: "130px",
        addFormOrder: 9,
        editFormOrder: 9,
        header: "City",
        derivedValue: "city=undefined",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "city",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "false",
        isFieldRequired: "true",
        required: true,
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: null,
        textAlign: "Center",
        show: false,
        field: "city",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "state",
        type: "text",
        placeholder: "State",
        label: "State",
        width: "130px",
        addFormOrder: 10,
        editFormOrder: 10,
        header: "State",
        derivedValue: "state=undefined",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "state",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "false",
        isFieldRequired: "true",
        required: true,
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: null,
        textAlign: "Center",
        show: false,
        field: "state",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "zip",
        type: "text",
        placeholder: "Zip",
        label: "Zip",
        width: "130px",
        addFormOrder: 11,
        editFormOrder: 11,
        header: "Zip",
        derivedValue: "zip=zip=undefined",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "zip",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "false",
        isFieldRequired: "true",
        required: true,
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: null,
        validationRequired: true,
        regexPattern: "^[0-9]$",
        regexData: {
          showMinField: false,
          minLengthRequired: false,
          minLengthText: null,
          showMaxField: false,
          maxLengthRequired: false,
          maxLengthText: null,
          alphabetsRequired: false,
          showAlphaField: false,
          numbersRequired: true,
          showNumField: true,
          specialCharRequired: false,
          showSCharField: false,
          specialCharText: null,
        },
        textAlign: "Center",
        show: false,
        field: "zip",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        show: true,
        textAlign: "center",
        width: 60,
        fieldType: "Actions",
        field: "Actions",
        header: "Actions",
        label: "Actions",
        filter: false,
        sortable: false,
        displayInSettings: true,
        displayinServer: "false",
        displayinlist: "true",
        displayinaddForm: "false",
        displayineditForm: "false",
        mobile: true,
      },
      {
        show: true,
        textAlign: "center",
        width: 60,
        fieldType: "Actions",
        field: "Actions",
        header: "Actions",
        label: "Actions",
        filter: false,
        sortable: false,
        displayInSettings: true,
        displayinServer: "false",
        displayinlist: "true",
        displayinaddForm: "false",
        displayineditForm: "false",
        mobile: true,
      },
    ];
    return data;
  };
  const closeFormModal = async () => {
    setIsOpenFormModal(false);
  };


  const cancelReset = async (type) => {
    setopenNewUserModal(false);
    window.location.reload();
  };

  const saveDataToServer = async (item, field, value) => {
    let body = item[0];
    body[field] = value;
    let userBody = Object.assign({}, body);

    if (body) {
      let method, apiUrl;
      method = "PUT";
      apiUrl = `${apiCalls["facilities"]}/${body._id}`;
      return fetchMethodRequest(method, apiUrl, userBody)
        .then(async (response) => {
          if (response && response.respCode) {
            showToasterMessage(response.respMessage, "success");
          } else if (response && response.errorMessage) {
            showToasterMessage(response.errorMessage, "error");
          }
        })
        .catch((err) => {
          return err;
        });
    } else {
      return;
    }
  };

  return (
    <span>
      {
        <DataTables
          {...props}
          getTableFields={getTableFields}
          formFields={getFormFields}
          //
          addRequired={false
            // rolePermission && rolePermission == "Edit" ? true : false
          }
          viewRequired={
            rolePermission && rolePermission == "Edit" ? true : false
          }
          editRequired={
            rolePermission && rolePermission == "Edit" ? true : false
          }
          deleteRequired={
            rolePermission && rolePermission == "Edit" ? true : false
          }
          printRequried={false}
          actionsTypes={false}
          settingsRequired={false}
          filterRequired={false}
          gridRequried={false}
          exportToCsv={true}
          getPagination={true}
          refresh={true}
          dateSearchRequired={false}
          searchInDateRangeField={""}
          setData={setData}
          selectionMode={true}
          editSelectedRecord={editSelectedRecord}
          addSelectedRecord={addSelectedRecord}
          viewSelectedRecord={viewSelectedRecord}
          sampleFilePath={filePath["tickets"]}
          globalSearch={"UserName / Email / Subject"}
          type="Tickets"
          routeTo={apiCalls["tickets"]}
          displayViewOfForm="modal"
          sideFormLeftOrRight=""
          apiResponseKey={apiCalls["tickets"].toLowerCase()}
          apiUrl={apiCalls["tickets"]}
          selectedId={params.id}
        />
      }
      {isOpenFormModal ? (
        <FormModal
          // onRef={(ref) => (this.formModalRef = ref)}
          formType="edit"
          openFormModal={isOpenFormModal}
          formFields={formFields}
        />
      ) : null}
      {openNewUserModal ? (
        <NewUserModal
          openNewUserModal={openNewUserModal}
          cancelReset={cancelReset}
          item={item}
          newFormFields={newFormFields}
          recordId={item._id}
          entityType="facilities"
          apiUrl={apiCalls["facilities"]}
        />
      ) : null}
    </span>
  );
};

export default Tickets;
